/*
  JustSmoke active Header Type 3 / mobile layout helper.
  The black hamburger is the category/full-menu trigger; the second mobile
  control remains the normal main-menu trigger. This helper explicitly
  initializes the black hamburger because Header Type 3 does not reliably
  run Wokiee's guarded category-menu initializer on every page.
*/
(function () {
  'use strict';

  function initDesktopCategoryHover() {
    var holders = document.querySelectorAll('.js-mega-category-holder');
    if (!holders.length) return;

    Array.prototype.forEach.call(holders, function (holder) {
      if (holder.dataset.jsHoverBridge === '1') return;
      var trigger = holder.querySelector('.js-mega-category-trigger');
      var menu = holder.querySelector('.js-mega-category-menu');
      if (!trigger || !menu) return;
      holder.dataset.jsHoverBridge = '1';

      var closeTimer;
      function openMenu() {
        clearTimeout(closeTimer);
        holder.classList.add('is-open');
      }
      function closeMenuSoon() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          holder.classList.remove('is-open');
        }, 140);
      }

      trigger.addEventListener('mouseenter', openMenu);
      trigger.addEventListener('mouseleave', closeMenuSoon);
      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenuSoon);
    });
  }

  function initMobileCategoryMenu() {
    if (window.innerWidth > 1024) return;
    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.initMM !== 'function') return;

    var $ = window.jQuery;
    var $buttons = $('header.headertype3 .tt-mobile-header .catmenumob-js');
    var $menu = $('.mobile-caterorie-menu');
    if (!$buttons.length || !$menu.length) return;

    $buttons.each(function () {
      var $button = $(this);
      if ($button.attr('data-js-full-menu-init') === '1') return;
      $button.attr('data-js-full-menu-init', '1');
      $button.initMM({
        enable_breakpoint: true,
        mobile_button: true,
        breakpoint: 1025,
        menu_class: 'mobile-caterorie-menu',
        close_button_name: typeof window.b_close !== 'undefined' ? window.b_close : 'Close',
        back_button_name: typeof window.b_back !== 'undefined' ? window.b_back : 'Back'
      });
    });
  }

  function syncMobileGiftsLayout() {
    var split = document.querySelector('.js-gifts-split-row');
    if (!split) return;

    var categories = split.querySelector('.js-gifts-categories-panel') || document.querySelector('.js-gifts-categories-panel');
    var row = categories && categories.querySelector('.tt-categories-listing > .row');
    var video = split.querySelector('.js-gifts-video-panel') || document.querySelector('.js-gifts-video-panel');
    if (!row || !video) return;

    if (window.innerWidth <= 767) {
      var tiles = [];
      Array.prototype.forEach.call(row.children, function (el) {
        if (el !== video && /(^|\s)col-/.test(el.className || '')) tiles.push(el);
      });
      var anchor = tiles[2] || null;
      if (video.parentNode !== row || video.nextSibling !== anchor) row.insertBefore(video, anchor);
      video.classList.add('js-mobile-gifts-video-inline');

      row.style.setProperty('display', 'grid', 'important');
      row.style.setProperty('grid-template-columns', 'repeat(2,minmax(0,1fr))', 'important');
      row.style.setProperty('gap', '12px', 'important');
      video.style.setProperty('grid-column', '1 / -1', 'important');
      video.style.setProperty('width', '100%', 'important');
    } else {
      video.classList.remove('js-mobile-gifts-video-inline');
      video.style.removeProperty('grid-column');
      video.style.removeProperty('width');
      row.style.removeProperty('display');
      row.style.removeProperty('grid-template-columns');
      row.style.removeProperty('gap');
      if (video.parentNode !== split) split.appendChild(video);
    }
  }

  function syncMobileShopcatLayout() {
    var split = document.querySelector('.js-shopcat-split-row');
    if (!split) return;

    var categories = split.querySelector('.js-shopcat-categories-panel') || document.querySelector('.js-shopcat-categories-panel');
    var grid = categories && categories.querySelector('.js-shopcat-card-grid');
    var video = split.querySelector('.js-shopcat-video-panel') || document.querySelector('.js-shopcat-video-panel');
    if (!grid || !video) return;

    if (window.innerWidth <= 767) {
      var cards = [];
      Array.prototype.forEach.call(grid.children, function (el) {
        if (el !== video && el.classList && el.classList.contains('js-fresh-shopcat-card')) cards.push(el);
      });
      var anchor = cards[2] || null;
      if (video.parentNode !== grid || video.nextSibling !== anchor) grid.insertBefore(video, anchor);
      video.classList.add('js-mobile-shopcat-video-inline');

      grid.style.setProperty('display', 'grid', 'important');
      grid.style.setProperty('grid-template-columns', 'repeat(2,minmax(0,1fr))', 'important');
      grid.style.setProperty('gap', '12px', 'important');
      video.style.setProperty('grid-column', '1 / -1', 'important');
      video.style.setProperty('width', '100%', 'important');
    } else {
      video.classList.remove('js-mobile-shopcat-video-inline');
      video.style.removeProperty('grid-column');
      video.style.removeProperty('width');
      grid.style.removeProperty('display');
      grid.style.removeProperty('grid-template-columns');
      grid.style.removeProperty('gap');
      if (video.parentNode !== split || split.firstElementChild !== video) split.insertBefore(video, split.firstChild);
    }
  }

  function hideMobileProductSectionTitleOverlays() {
    if (window.innerWidth > 767) return;

    var sectionSelectors = [
      '#shopify-section-index_section_products_bestsellers',
      '#shopify-section-index_section_products_UtV3VC',
      '#shopify-section-index_section_products_L77DxG'
    ];

    sectionSelectors.forEach(function (selector) {
      var section = document.querySelector(selector);
      if (!section) return;

      Array.prototype.forEach.call(section.querySelectorAll('.tt-block-title, .js-section-title'), function (el) {
        if (el.closest('.tt-product')) return;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('margin', '0', 'important');
        el.style.setProperty('padding', '0', 'important');
        el.style.setProperty('border', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });

      Array.prototype.forEach.call(section.querySelectorAll('h1,h2,h3,h4,h5,h6,[class*="title"],[class*="heading"]'), function (label) {
        if (label.closest('.tt-product')) return;
        var text = (label.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
        if (text !== 'BEST SELLERS') return;

        var wrapper = label.closest('.tt-block-title, .js-section-title, [class*="section-title"], [class*="heading-block"], [class*="title-block"]') || label;
        if (wrapper.closest('.tt-product')) return;
        wrapper.style.setProperty('display', 'none', 'important');
        wrapper.style.setProperty('height', '0', 'important');
        wrapper.style.setProperty('min-height', '0', 'important');
        wrapper.style.setProperty('max-height', '0', 'important');
        wrapper.style.setProperty('margin', '0', 'important');
        wrapper.style.setProperty('padding', '0', 'important');
        wrapper.style.setProperty('border', '0', 'important');
        wrapper.style.setProperty('overflow', 'hidden', 'important');
      });
    });
  }

  function runMobileLayoutFixes() {
    syncMobileGiftsLayout();
    syncMobileShopcatLayout();
    hideMobileProductSectionTitleOverlays();
  }

  function init() {
    initDesktopCategoryHover();
    initMobileCategoryMenu();
    runMobileLayoutFixes();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initMobileCategoryMenu();
        runMobileLayoutFixes();
      }, 120);
    });
    window.addEventListener('load', function () {
      initMobileCategoryMenu();
      runMobileLayoutFixes();
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () {
        initMobileCategoryMenu();
        runMobileLayoutFixes();
      }, 0);
    });

    setTimeout(initMobileCategoryMenu, 250);
    setTimeout(initMobileCategoryMenu, 900);
    setTimeout(initMobileCategoryMenu, 1800);
    setTimeout(runMobileLayoutFixes, 250);
    setTimeout(runMobileLayoutFixes, 900);
    setTimeout(runMobileLayoutFixes, 1800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();